import { createSelector } from 'selectors'

import { useState } from '@/hooks'
import { appModels } from '@/models'

export const GlobalService = (() => {
	const { lang } = createSelector<HTMLElement>({ selector: 'html' })
	const { state, setState } = useState<appModels.AppState>({ lang, filter: {} })

	const registerAppConfig = () => {
		setTimeout(() => {
			setState(window.appConfig)
		}, 10)
	}

	const getState = () => state

	const getLang = () => state.lang || 'en'

	return {
		registerAppConfig,
		getState,
		getLang,
	}
})()
